import { WarehouseRoutingCheckInAPIService } from "./warehouseRoutingCheckInAPIService";
import { WarehouseRoutingCheckIn } from "src/types/database";

class WarehouseRoutingCheckInService {
  private readonly apiService: WarehouseRoutingCheckInAPIService;

  constructor(apiService: WarehouseRoutingCheckInAPIService) {
    this.apiService = apiService;
  }

  async createRoutingCheckIn(
    purchaseOrderId: string,
    products: Array<{ id: string; receivedQty: number }>,
    defects?: string
  ): Promise<WarehouseRoutingCheckIn> {
    return await this.apiService.postWarehouseRoutingCheckIn(purchaseOrderId, { products, defects });
  }

  async getAllByPurchaseOrderId(purchaseOrderId: string): Promise<WarehouseRoutingCheckIn[]> {
    return await this.apiService.getWarehouseRoutingCheckIns(purchaseOrderId);
  }
}

export { WarehouseRoutingCheckInService };
